import NoMatchRedirect from '../pages/NoMatchRedirect'

export default [
{
  path:'',
  component: NoMatchRedirect,
  title: 'YWait - Access Code'
}]